import { PhTextAlignLeft } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type CampaignResource,
  type CTAButtonSection,
  type CTAButtonSectionCreate,
  type CTAButtonSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import { createCTAButtonData } from './methods/createCTAData'
import CTAButtonPreview from './preview/CTAButtonPreview.vue'
const i18n = i18nPlugin.global

export const CTAButtonBlockModule: BuilderBlockModule<
  CTAButtonSection,
  CTAButtonSectionCreate,
  CTAButtonSectionUpdate,
  CampaignResource
> = {
  canAdd: false,
  canDelete: false,
  canReorderDown: false,
  canReorderUp: false,
  createData: createCTAButtonData,
  meta: [
    {
      icon: PhTextAlignLeft,
      key: 'cta',
      label: i18n.t('email-builder.blocks.cta-section'),
    },
  ],
  methods: emailBlockMethods,
  preview: CTAButtonPreview,
}
